// extracted by mini-css-extract-plugin
export default {"notifications":"Avatar_notifications__M-jxC"};